// FASE 1.4 — Render text with @mentions as clickable profile links.
// Used by AnalysisComments and AnalysisCard descriptions.
import React from "react";
import { Link } from "react-router-dom";

const MENTION_RE = /(@[a-zA-Z0-9_]{3,20})/g;

export const renderWithMentions = (text) => {
  if (!text) return null;
  const parts = String(text).split(MENTION_RE);
  return parts.map((part, idx) => {
    if (MENTION_RE.test(part)) {
      const username = part.slice(1);
      MENTION_RE.lastIndex = 0; // reset, exec is stateful
      return (
        <Link
          key={idx}
          to={`/shadow/perfil/${username}`}
          onClick={(e) => e.stopPropagation()}
          className="font-bold text-cyan-300 transition-colors hover:text-cyan-200 hover:underline"
          data-testid={`mention-link-${username}`}
        >
          {part}
        </Link>
      );
    }
    return <React.Fragment key={idx}>{part}</React.Fragment>;
  });
};

export default renderWithMentions;
